module.exports = __webpack_public_path__ + "static/media/home_medical_certificate_icon.4d9c213e.png";